import React from "react";

const About = () => {
  return (
    <div className="bg-white text-gray-900">

      <section className="relative h-[60vh] flex items-center justify-center text-center text-white">
        <img
          src="https://images.pexels.com/photos/3182763/pexels-photo-3182763.jpeg"
          alt="about"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70"></div>

        <div className="relative z-10 px-6">
          <h1 className="text-4xl md:text-6xl font-bold">
            About Our Company
          </h1>
          <p className="mt-4 text-lg text-gray-200 max-w-2xl mx-auto">
            Building digital solutions that drive growth and innovation.
          </p>
        </div>
      </section>


      <section className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-12 items-center">

        <div>
          <img
            src="https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg"
            alt="team"
            className="rounded-3xl shadow-xl hover:scale-105 transition duration-500"
          />
        </div>

        <div>
          <h2 className="text-3xl font-bold">
            Who We Are
          </h2>

          <p className="mt-4 text-gray-600 leading-relaxed">
          *Om internet services<br/> *Founded in 1998 by Late Shri Ajay Sharma, our company was built on a powerful vision — recognizing early on that the future belongs to technology and digital transformation. At a time when the digital era was just beginning, he laid the foundation with foresight, dedication, and a commitment to innovation.

Today, the legacy continues under the leadership of his son, Bhuvesh Sharma, who is carrying forward the same vision with modern expertise and a forward-thinking approach. With a deep understanding of evolving digital trends, we aim to empower businesses to thrive in today’s competitive online world.


          </p>

          <p className="mt-4 text-gray-600 leading-relaxed">
            We specialize in providing a wide range of digital solutions, including professional website development, result-driven digital marketing, e-commerce templates, and customized software development. Our goal is to deliver high-quality, scalable, and user-friendly solutions tailored to meet the unique needs of each client.
          </p>

       <a
  href="https://www.google.com"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block mt-6 px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-full"
>
  Learn More →
</a>
        </div>
      </section>

      <section className="bg-gray-50 py-24 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10">

          <div className="p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl hover:scale-105 transition">
            <h3 className="text-2xl font-bold text-red-600">
              Our Mission
            </h3>
            <p className="mt-4 text-gray-600">
              To empower businesses with modern digital solutions and help them
              achieve sustainable growth in the competitive online world.
            </p>
          </div>

          <div className="p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl hover:scale-105 transition">
            <h3 className="text-2xl font-bold text-red-600">
              Our Vision
            </h3>
            <p className="mt-4 text-gray-600">
              To become a trusted leader in the IT industry by delivering
              innovation and excellence.
            </p>
          </div>

        </div>
      </section>


      <section className="py-24 px-6 text-center">
        <h2 className="text-3xl font-bold">Our Core Values</h2>

        <div className="mt-12 max-w-6xl mx-auto grid md:grid-cols-3 gap-8">

          <div className="p-6 rounded-2xl shadow-md hover:shadow-xl hover:scale-105 transition">
            <h3 className="text-xl font-semibold text-red-600">Innovation</h3>
            <p className="mt-2 text-gray-600">
              We create modern and creative solutions for businesses.
            </p>
          </div>

          <div className="p-6 rounded-2xl shadow-md hover:shadow-xl hover:scale-105 transition">
            <h3 className="text-xl font-semibold text-red-600">Quality</h3>
            <p className="mt-2 text-gray-600">
              Delivering high-quality services is our top priority.
            </p>
          </div>

          <div className="p-6 rounded-2xl shadow-md hover:shadow-xl hover:scale-105 transition">
            <h3 className="text-xl font-semibold text-red-600">Trust</h3>
            <p className="mt-2 text-gray-600">
              Building long-term relationships with clients.
            </p>
          </div>

        </div>
      </section>


      <section className="py-24 px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center">

          <div className="p-6 bg-gray-100 rounded-2xl hover:scale-105 transition">
            <h3 className="text-3xl font-bold text-red-600">100+</h3>
            <p className="text-gray-600 mt-2">Projects</p>
          </div>

          <div className="p-6 bg-gray-100 rounded-2xl hover:scale-105 transition">
            <h3 className="text-3xl font-bold text-red-600">50+</h3>
            <p className="text-gray-600 mt-2">Clients</p>
          </div>

          <div className="p-6 bg-gray-100 rounded-2xl hover:scale-105 transition">
            <h3 className="text-3xl font-bold text-red-600">5+</h3>
            <p className="text-gray-600 mt-2">Years Experience</p>
          </div>

          <div className="p-6 bg-gray-100 rounded-2xl hover:scale-105 transition">
            <h3 className="text-3xl font-bold text-red-600">24/7</h3>
            <p className="text-gray-600 mt-2">Support</p>
          </div>

        </div>
      </section>


      <section className="bg-gray-50 py-24 px-6 text-center">
        <h2 className="text-3xl font-bold">Meet Our Team</h2>

        <div className="mt-12 max-w-6xl mx-auto grid md:grid-cols-3 gap-8">

          <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:scale-105 transition">
            <img
              src="https://randomuser.me/api/portraits/men/32.jpg"
              alt=""
              className="w-24 h-24 mx-auto rounded-full"
            />
            <h3 className="mt-4 font-semibold text-lg">John Doe</h3>
            <p className="text-gray-500">Web Developer</p>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:scale-105 transition">
            <img
              src="https://randomuser.me/api/portraits/women/44.jpg"
              alt=""
              className="w-24 h-24 mx-auto rounded-full"
            />
            <h3 className="mt-4 font-semibold text-lg">Sarah Khan</h3>
            <p className="text-gray-500">UI/UX Designer</p>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl hover:scale-105 transition">
            <img
              src="https://randomuser.me/api/portraits/men/76.jpg"
              alt=""
              className="w-24 h-24 mx-auto rounded-full"
            />
            <h3 className="mt-4 font-semibold text-lg">Aman Singh</h3>
            <p className="text-gray-500">Digital Marketer</p>
          </div>

        </div>
      </section>


      <section className="bg-red-600 py-20 text-center text-white">
        <h2 className="text-3xl font-bold">
          Ready to Grow Your Business?
        </h2>

        <p className="mt-4 text-lg">
          Let’s build something amazing together.
        </p>

        <button className="mt-6 px-8 py-3 bg-white text-red-600 rounded-full font-semibold hover:bg-gray-200 transition">
          Contact Us
        </button>
      </section>

    </div>
  );
};

export default About;